<template>
  <section class="addressInfo">
    <div class="addressInfo__main">
      <div class="addressInfo__main--left">
        <span>{{data.contact_info[0].title}}</span>
        <p v-if="!data.contact_info[0].create_link_for_email" v-html="data.contact_info[0].info"></p>
        <a v-else :href="`mailto:${data.contact_info[0].info}`" v-html="data.contact_info[0].info"></a>
        <Button
        v-if="data.link.title"
        color="white"
        lineHover="bg-orange"
        circleColor="circle-white"
        :text="data.link.title"
        :url="data.link.url"
        :target="data.link.target"
      />
      </div>
      <div class="addressInfo__main--right">
        <div class="info">
          <span>{{data.contact_info[1].title}}</span>
          <p v-if="!data.contact_info[1].create_link_for_email" v-html="data.contact_info[1].info"></p>
        <a v-else :href="`mailto:${data.contact_info[1].info}`" v-html="data.contact_info[1].info"></a>
        </div>
        <div class="info">
          <span>{{data.contact_info[2].title}}</span>
          <p v-if="!data.contact_info[2].create_link_for_email" v-html="data.contact_info[2].info"></p>
        <a v-else :href="`mailto:${data.contact_info[2].info}`" v-html="data.contact_info[2].info"></a>
        </div>
      </div>
    </div>

  </section>
</template>

<script setup>
import Button from '@/components/utility/Button.vue'
defineProps(['data'])

</script>

<style lang="scss" scoped>
  .addressInfo{
    @apply main-container py-16 md:py-32 lg:py-48 lg:pl-14;
    &__main{
      @apply flex flex-col lg:flex-row justify-between gap-16 md:gap-32 lg:gap-12;
      &--left{
        @apply w-full lg:w-2/3;
        span{
          @apply text-xl leading-6 font-medium mb-8 block;
        }
        a, p{
          @apply text-3xl md:text-6xl lg:text-[70px] lg:leading-[70px] font-medium;
        }
      }
      &--right{
        @apply w-full lg:w-1/3 flex flex-col md:flex-row lg:flex-col justify-between;
        .info{
          @apply mb-14;
          span{
          @apply text-xl leading-6 font-medium mb-7 block;
        }
        a, p{
          @apply text-[40px] font-medium h-[60px] flex items-center;

        }
      }
    }
  }
}

</style>
